import { getAuthGateUrl } from '@chegg/one-auth-sdk';
export async function fetchCountry() {
  return await query(getAuthGateUrl(), {
    query: "{ geolocation { countryCode countryName} }"
  });
}
async function query(url, data) {
  var response = await fetch(url, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify(data)
  });
  var parsedResponse = await response.json();
  if (!response.ok) {
    var errorData = parsedResponse && JSON.stringify(parsedResponse);
    throw new Error(errorData);
  }
  return parsedResponse;
}